/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Detail_SizeInputs */

const es_chat_tool_detail_size = /** @type {(inputs: Chat_Tool_Detail_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño`)
};

const en_chat_tool_detail_size = /** @type {(inputs: Chat_Tool_Detail_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Size`)
};

/**
* | output |
* | --- |
* | "Size" |
*
* @param {Chat_Tool_Detail_SizeInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_tool_detail_size = /** @type {((inputs?: Chat_Tool_Detail_SizeInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Detail_SizeInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_tool_detail_size(inputs)
	return en_chat_tool_detail_size(inputs)
});
export { chat_tool_detail_size as "chat.tool_detail.size" }